import { render } from "./KeyValueItem.vue?vue&type=template&id=35580d58"
import script from "./KeyValueItem.vue?vue&type=script&lang=js"
export * from "./KeyValueItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"KeyValueItem.vue"]])

export default __exports__